<template>
    <div id="autocomplete" style="position: relative">
        <input
            class="form-control"
            :placeholder="placeholder"
            v-model="query"
            @input="search"
        />
        <ul
            class="list-group"
            style="position: absolute; width: 100%; z-index: 9999999"
        >
            <li
                v-bind:key="index"
                v-for="(suggestion, index) in suggestions"
                class="list-group-item"
                @click="choose(suggestion)"
            >
                <a href="javascript:;">{{ suggestion.nama }}</a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "autocomplete",
    props: ["placeholder", "data", "value", "resetable", "depth"],
    data: function () {
        return {
            suggestions: [],
            index: [],
            query: "",
        };
    },
    watch: {
        value: function (val) {
            this.query = val;
        },
    },
    methods: {
        choose: function (selected) {
            this.query = selected.nama;
            this.suggestions = [];

            var result = {
                test: "",
                data: [0, 0, 0],
            };

            var index = 0;
            selected.parents.forEach(function (topic) {
                result.data[index] = topic.id;
                index++;
            });

            result.data[index] = selected.id;
            result.text = selected.nama;
            this.$emit("selected", result);
            if (this.resetable) this.query = "";
        },
        search: function () {
            this.suggestions = [];
            if (this.query.length > 0) {
                var context = this;
                this.data.forEach(function (node) {
                    context.traverse(context.query, node, [], 1);
                });
            }
        },
        traverse: function (query, node, parents, level) {
            if (
                query.length > 3 &&
                node.nama.toLowerCase().indexOf(this.query.toLowerCase()) >= 0
            ) {
                var nodepath = "";
                parents.forEach(function (parent) {
                    nodepath += parent.nama + " >> ";
                });

                this.suggestions.push({
                    id: node.id,
                    nama: nodepath + node.nama,
                    parents: parents,
                });
            }

            if (parseInt(this.depth) && level === parseInt(this.depth)) {
                return;
            }

            if (node.subs.length === 0) {
                return;
            }

            for (var i = 0; i < node.subs.length; i++) {
                this.traverse(
                    query,
                    node.subs[i],
                    parents.concat(node),
                    level + 1,
                );
            }
        },
        refresh: function () {
            this.query = "";
        },
    },
};
</script>



// WEBPACK FOOTER //
// Autocomplete.vue?d4fb453c